module.exports = "/resources/assets/prod/a3f559d11d56fbd7a266b632e0df65a3.svg";